{
  "#FREIGABE": {
    "TITLE": "Freigabe",
    "PAGES": {
      "LIST": {
        "HEADER": "Freigaben",
        "FILTER": "Suchen / Filtern"
      }
    },
    "MENU": {
      "LIST": "Liste",
      "OPEN": "Freigabefenster öffnen",
      "FREIGABE": "Freigeben"
    },
    "MESSAGES": {
      "SUCCESS": {
        "UPLOAD": "Das Dokument wurde hochgeladen",
        "SAVE": "Die Daten wurden gespeichert",
        "NEXT": "Die neue Status wurde gesetzt"
      },
      "WARNING": {
        "LOAD_DEFINITIONS": "Das kundenspezifische Layout konnte nicht geladen werden."
      },
      "ERROR": {
        "UPLOAD": "Das Dokument konnte nicht hochgeladen werden",
        "SAVE": "Die Daten konnten nicht gespeichert werden",
        "NEXT": "Die neue Status konnte nicht gesetzt werden"
      }
    }
  }
}
